import { IResponse, consumer } from '@bemap/utils';

export interface LeadDTO {
  id: number;
  name: string;
  email: string;
  phone?: string | null;
  team_id: number;
  campaign_link_id: number;
  profile_id?: number | null;
  assessment_id?: number | null;
  created_at?: string;
  deal_value?: string | null;
  expected_close_at?: string | null;
}

export const listLeads = async (): Promise<IResponse> => {
  return consumer('GET', `/leads`);
};

export const getLead = async (id: number): Promise<IResponse> => {
  return consumer('GET', `/leads/${id}`);
};

export const updateLead = async (
  id: number,
  payload: Partial<Pick<LeadDTO, 'name' | 'phone' | 'deal_value' | 'expected_close_at'>>,
): Promise<IResponse> => {
  return consumer('PATCH', `/leads/${id}`, payload);
};

export const deleteLead = async (id: number): Promise<IResponse> => {
  return consumer('DELETE', `/leads/${id}`);
};

export default {
  listLeads,
  getLead,
  updateLead,
  deleteLead,
};


